import React from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactDOM from "react-dom";
import { traducirPagina, obtenerUsuario, obtenerToken, MSGOK } from "../../librerias/funciones";
import { ObtenerConfiguracionMensajeriaEnAPI, ModificarConfiguracionMensajeriaEnAPI } from "../../action/actionCreatorsRequests";
import { CPCard } from "../../components/Utils/Card/CPCard"
import { Select } from "antd";
import { CPSwitch } from "../Utils/Switch/CPSwitch";




const { Option } = Select;
const Mensajeria = ({ }) => {
    const [alturaSubmenu, setAlturaSubmenu] = React.useState(0);
    const ref = React.useRef(null)

    const [sociosLocal, setSociosLocal] = React.useState([]);
    const [permisoTelegram, setPermisoTelegram] = React.useState(false);
    const [socioSeleccionado, setSocioSeleccionado] = React.useState(0);


    const ObtenerConfiguracionMensajeria = (ID_SOCIO) => {
        ObtenerConfiguracionMensajeriaEnAPI(ID_SOCIO).then((registro) => {
            if (registro !== undefined && registro.REGISTROS !== null && registro.REGISTROS.length > 0) {
                setPermisoTelegram(registro.REGISTROS[0].PERMISO_TELEGRAM)
            } else {
                setPermisoTelegram(false)
            }
        })
    }


    const ModificarConfiguracionMensajeria = (ID_SOCIO, PERMSIO) => {
        ModificarConfiguracionMensajeriaEnAPI(ID_SOCIO, PERMSIO).then((registro) => {
            if (registro.OK) {
                MSGOK("Permiso actualizado correctamente")
            }
        })
    }

    const eventoSwitch = (estado) => {
        ModificarConfiguracionMensajeria(socioSeleccionado, estado);
        setPermisoTelegram(estado)
    }


    React.useEffect(() => {
        if (ref.current !== null) {
            setAlturaSubmenu(ref.current.clientHeight)
        }
    })

    React.useEffect(() => {
        if (obtenerToken() !== undefined) {
            let accesoLicencia = obtenerUsuario();
            setSociosLocal(accesoLicencia.SOCIOS)
            ObtenerConfiguracionMensajeria(accesoLicencia.SOCIOS[0].ID_SOCIO)
            setSocioSeleccionado(accesoLicencia.SOCIOS[0].ID_SOCIO)
        }
    }, [])



    document.getElementById("tituloMenu") !== null && ReactDOM.render(
        <>
            {`SERTEC - ${traducirPagina("Mensajeria")}`}
        </>,
        document.getElementById("tituloMenu")
    );



    return (
        <div>
            <div className="menu_mantenimiento" ref={ref}>
                <div className="mantenimiento_item1">

                </div>

                <div className="mantenimiento_item2" style={{ gap: '10px' }}>
                    <div>
                        {sociosLocal !== null ?
                            <Select
                                showSearch
                                allowClear={obtenerUsuario().SOCIOS.length > 1 ? true : false}
                                defaultValue={obtenerUsuario() !== null ? obtenerUsuario().SOCIOS[0].ID_SOCIO : ""}
                                size={"large"}
                                placeholder={traducirPagina("Seleccione_socio")}
                                style={{ width: "400px", textAlign: 'left' }}
                                optionFilterProp="children"
                                onChange={(e) => {
                                    if (e === undefined || e === null) {
                                        setSocioSeleccionado(0)
                                    } else {
                                        setSocioSeleccionado(parseInt(e));
                                        ObtenerConfiguracionMensajeria(parseInt(e))
                                    }
                                }}
                                filterOption={(input, option) =>
                                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {sociosLocal.length > 0 ?
                                    sociosLocal.map((socio) =>
                                        <Option key={socio.ID_SOCIO} value={socio.ID_SOCIO}>{socio.NOMBRE_SOCIO}</Option>
                                    )
                                    :
                                    null
                                }
                            </Select>
                            :
                            <div style={{ textAlign: 'center' }}>
                                <h4>{traducirPagina("Info_error_socio")}</h4>
                            </div>
                        }
                    </div>
                </div>
            </div>


            <div className="margen_tabla">
                <div className="container_tabla_generico container_mensajeria" style={{ height: `calc(100vh - ${(120 + alturaSubmenu)}px )` }}>
                    <CPCard className="card_mensajeria">
                        <div className="container_switch">
                            <CPSwitch
                                seleccionado={permisoTelegram}
                                onClickChange={eventoSwitch}
                            >
                            </CPSwitch>

                            <span >{traducirPagina("Info_mensajeria")} </span>
                        </div>
                    </CPCard>

                </div>
            </div>

        </div>
    )

}


Mensajeria.propTypes = {
};


const mapStateToProps = (state, props) => {
    return {
        props: props
    };
}

export default connect(mapStateToProps)(Mensajeria);
